import DB from "./db"
import { evalFN } from "./utils"
const JS_ATTRIBUTE = 'altihexjs'
const CSS_ATTRIBUTE = 'altihexcss'
const VERSION_NAME = 'altihexversion'
export const injectionSDK = (js: string, css: string, version: string, db: DB) => {
  
  return new Promise((resolve, reject) => {
    let jsString = loadJsData({db, version, js})
    let cssString = loadStyleData({db, version, css}) 
    
    

    Promise.all([jsString, cssString]).then(([jsData, cssData]) => {
      injectionCss(cssData, version)
      injectionJs(jsData)
      resolve(version)
    }).catch((e) => reject(e))

  })
}

function loadJsData({db, version, js}:{db: DB, version: string, js: string}) {

  const jsDBName =  `${JS_ATTRIBUTE}_${version}`
  const jsVersion = 'altihex' + version.replace(/\./g,'_')
  // @ts-ignore
  if(window[`altihex${jsVersion}`]) return Promise.resolve()
  return db.get(jsDBName).then((data) => {
    if(data.status === 200 && data.data){
      return Promise.resolve(data).then(data => data.data.value)
    }else {
      console.log(jsDBName, '失败js', data)
      return fetch(js).then(res => res.text()).then(data => {
        db.add({id: jsDBName, value: data})
        return data
      })
    }
  })

}

function loadStyleData({db, version, css}: {db: DB, version: string, css: string}) {
  const styleDBName =  `${CSS_ATTRIBUTE}_${version}`
  const styleVersion = 'v' + version.replace(/\./g, '')
  const inlineStyle = document.querySelector(`[${VERSION_NAME}=${styleVersion}]`)
  if(inlineStyle) return Promise.resolve()
  return db.get(`${CSS_ATTRIBUTE}_${version}`).then((data) => {
    if(data.status === 200 && data.data){
      return Promise.resolve(data).then(data => data.data.value)
    }else {
      console.log(`${CSS_ATTRIBUTE}_${version}`,'失败css', data)
      return fetch(css).then(res => res.text()).then(data => {
        db.add({id: styleDBName, value: data})
        return data
      })
    }
  }).catch(() => {
    return fetch(css).then(res => res.text()).then(data => {
      db.add({id: styleDBName, value: data})
      return data
    })
  })
}


function injectionJs(js: string) {
  if(js){
    evalFN(js)()
  }

}



function injectionCss(css: string | undefined, version: string) {
  if(!css) return
  const styleVersion = 'v' + version.replace(/\./g, '')
  const style: HTMLLinkElement = document.createElement("style") as HTMLLinkElement;
  style.innerHTML = css
  style.type = 'text/css'
  style.rel = 'stylesheet'
  style.setAttribute(CSS_ATTRIBUTE, '')
  style.setAttribute(VERSION_NAME, styleVersion)
  document.head.appendChild(style);
}
